import { AnalyticsPermissions } from './analytics.permissons';
import { AnalyticsRoles } from './analytics.roles';

export const analyticsMappings = {
  [AnalyticsPermissions.GET_CHART_DATA]: [AnalyticsRoles.VIEWER],
  [AnalyticsPermissions.VIEW_EMBEDDED_DASHBOARD]: [AnalyticsRoles.VIEWER],
  [AnalyticsPermissions.RUN_SELF_SERVE_QUERY]: [
    AnalyticsRoles.SELF_SERVE_ANALYST,
  ],
};
